<template>
  <b-row class="d-flex flex-wrap align-items-stretch mb-2">
    <b-col cols="12" md="4">
      <b-card no-body class="h-100">
        <b-card-body>
          <b-row>
            <b-col md="12">
              <div class="d-flex">
                <feather-icon
                  size="20"
                  icon="UsersIcon"
                  class="text-muted mr-1"
                />
                <h4 class="text-muted">Total Customers</h4>
              </div>
            </b-col>
            <b-col md="12"
              ><h3>{{ statistics.totalCustomers }}</h3></b-col
            >
            <b-col md="12">
              <span class="text-primary"
                >+{{ statistics.newSignupsThisMonth }} this month</span
              ></b-col
            >
          </b-row>
        </b-card-body>
      </b-card>
    </b-col>

    <b-col cols="12" md="4">
      <b-card no-body class="h-100">
        <b-card-body>
          <b-row>
            <b-col md="12">
              <div class="d-flex justify-content-between">
                <h4 class="text-muted">Active Customers</h4>
              </div>
            </b-col>
            <b-col md="12"
              ><h3>{{ statistics.activeCustomers }}</h3></b-col
            >
            <b-col md="12">
              <span class="text-primary"
                >{{ statistics.activeCustomersPercentage }}% of total</span
              ></b-col
            >
          </b-row>
        </b-card-body>
      </b-card>
    </b-col>

    <b-col cols="12" md="4">
      <b-card no-body class="h-100">
        <b-card-body>
          <b-row>
            <b-col md="12">
              <div class="d-flex justify-content-between">
                <h4 class="text-muted">New Signups Today</h4>
              </div>
            </b-col>
            <b-col md="12"
              ><h3>{{ statistics.newSignupsToday }}</h3></b-col
            >
            <b-col>
              <b-badge pill variant="primary">
                Deposits:
                {{ formatCurrencyBuiltInFunc(statistics.depositAmountToday) }}
              </b-badge>
            </b-col>
          </b-row>
        </b-card-body>
      </b-card>
    </b-col>
  </b-row>
</template>

<script>
import { BBadge, BCard, BCardBody, BRow, BCol } from "bootstrap-vue";
import { objectProp } from "@/helpers/props";
import { formatCurrencyBuiltInFunc } from "@/helpers/utils";

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardBody,
    BBadge,
  },
  props: {
    statistics: objectProp(),
  },
  data() {
    return {};
  },
  methods: {
    formatCurrencyBuiltInFunc,
  },
};
</script>

<style lang="scss"></style>
